import React from 'react';
import { View, Text, StyleSheet, Image } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    headerContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 10,
        paddingBottom: 10,
        borderBottomWidth: 1,
        borderBottomColor: '#004899',
        backgroundColor: '#ffffff',
    },
    headerLogo: {
        width: 60,
        height: 60,
    },
    headerTextContainer: {
        flex: 1,
        alignItems: 'center',
    },
    headerTitle: {
        color: '#004899',
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 3,
    },
    projectIdContainer: {
        backgroundColor: '#f0f5ff',
        padding: 6,
        borderRadius: 4,
        borderLeftWidth: 2,
        borderLeftColor: '#004899',
    },
    projectIdLabel: {
        color: '#666',
        fontSize: 8,
        fontWeight: 'bold',
    },
    projectIdValue: {
        color: '#004899',
        fontSize: 10,
        fontWeight: 'bold',
    },
    confidentialText: {
        color: '#FF0000',
        fontSize: 8,
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: 10,
        fontStyle: 'italic',
    },
});

interface HeaderSectionProps {
    projectId: string;
    createdAt: string;
}

export const NewHeaderSection: React.FC<HeaderSectionProps> = ({ projectId, createdAt }) => {
    const date = new Date(createdAt);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const formattedId = `${year}${month}-PT${projectId}`;

    return (
        <>
            <View style={styles.headerContainer}>
                <Image src={'/pepsi-main.png'} style={styles.headerLogo} />
                <View style={styles.headerTextContainer}>
                    <Text style={styles.headerTitle}>Ship And Stack Testing Report</Text>
                    <View style={styles.projectIdContainer}>
                        <Text style={styles.projectIdLabel}>Project ID</Text>
                        <Text style={styles.projectIdValue}>{formattedId}</Text>
                    </View>
                </View>
                <View style={{ width: 60 }} /> {/* Spacer for alignment */}
            </View>
            <Text style={styles.confidentialText}>PRIVILEGED AND CONFIDENTIAL - PROPERTY OF PEPSICO, INC.</Text>
        </>
    );
}; 